import FooterSection from "assets/Footer";
import Navbar from "assets/Navbar";
import check from "../../src/images/check.png"
import { Link } from "react-router-dom";

const ConfirmOrder = () => {

    return (
        <div className="flex flex-col min-h-[100dvh] bg-[#F5F5F5]">
            <Navbar />
            <div className="flex-1 flex items-center justify-center">
    <div className="flex flex-col items-center justify-center text-center">

                    <img
                        src={check}
                        alt="Confirm"
                        className="w-[100px] md:w-[150px] h-auto "
                    />
                    <p className="my-5 text-gray-700 text-center md:text-base text-sm">
                        💖 আপনার অর্ডারটি কনফার্ম করা হয়েছে, <br />
                        খুব শীঘ্রই আমাদের প্রতিনিধি আপনার সাথে যোগাযোগ করবে 💖
                    </p>
                    <Link to="/" className="bg-backgroundColor text-white py-2 px-5 rounded md:text-sm text-xs">
                        আরো অর্ডার করতে বা পণ্য দেখতে এখানে ক্লিক করুন
                    </Link>

                </div>
            </div>
            <FooterSection />
        </div >
    );
};

export default ConfirmOrder;
